// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import api from './api/api.js'
import moment from 'moment'
import axios from 'axios'


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../theme/index.css';
import VueCookie from 'vue-cookie'
import VueClipboard from 'vue-clipboard2'
import VueResource from 'vue-resource'

Vue.prototype.$api = api
Vue.prototype.$moment = moment

Vue.use(ElementUI);
Vue.use(router);
Vue.config.productionTip = false;
window.cookie = VueCookie
Vue.use(VueResource)
Vue.use(axios)

Vue.use(VueClipboard)
//动态设置页面标题
router.beforeEach((to, from, next) => {
  var _hmt = _hmt || [];
  (function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?ef5bfd8e07ee4bb29ff5d7b99eb4e55c";
    var s = document.getElementsByTagName("script")[0]; 
    s.parentNode.insertBefore(hm, s);
  })();
  console.log(to, from)
  //window.document.title = to.meta.title;
  next();
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js